import * as firebase from 'firebase'
import db from './db'

interface Props {
  userID?: string
}

// Make a note of when the page loaded. If a command is newer than that, we'll
// run it.
const pageStartDate = new Date()

const RemoteControl = ({ userID }: Props) => {
  const user = firebase.auth().currentUser
  if (user) {
    db.collection('remoteControlCommands')
      .where('userID', '==', user.uid)
      .where('date', '>', pageStartDate)
      .onSnapshot(snapshot => {
        if (snapshot.docs && snapshot.docs.length) {
          const command = snapshot.docs[snapshot.docs.length - 1].data()
          if (command.command === 'reload') {
            window.location.reload()
          } else if (command.command === 'redirect') {
            window.location.href = command.redirect
          }
        }
      })
  }
  return null
}

export default RemoteControl



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/RemoteControl.ts